export default __webpack_public_path__ + "static/media/txt.2afb09fd.png";